<template>
  <div id="app" class="page">
    <speed v-if="isSpeedPage"></speed>
    <template v-else>
      <header-nav></header-nav>
      <desktop></desktop>
    </template>
  </div>
</template>

<script>
import headerNav from '@/components/header/index';
import desktop from '@/components/desktop/index';
import speed from '@/components/speed/index';

export default {
  name: 'App',
  components: {
    desktop,
    headerNav,
    speed,
  },
  data() {
    return {
      isSpeedPage: window.location.pathname.startsWith('/speed'),
    };
  },
  computed: {
  },
  watch: {
  },
  destroyed() {
  },
  methods: {
  },
};
</script>
